module.exports = __webpack_public_path__ + "static/media/Section-Bulk-Upload-Products-Demo-Template.457cc86e.xlsx";